import { router } from "expo-router";
import { ProfileForm } from "~/components/form/auth/ProfileForm";
import { Authorize } from "~/components/permission/Authorize";
import { Nothing } from "~/components/permission/Nothing";
import { useSession } from "~/providers/SessionProvider";

export default function EditProfile() {
    const { is_share_user } = useSession();
    const dismiss = () => router.dismissTo("/more/account/account-details");

    if (is_share_user) {
        setTimeout(dismiss, 10);

        return <Nothing />;
    }

    return (
        <Authorize ability="update" section="profile" show={() => <ProfileForm asRoute onRequestClose={dismiss} />} />
    );
}
